import { joinedLoadingElementClassNames } from "src/base/constants/layout";
import { remotePath } from "src/base/settings/Paths";

export const renderLoading = (ebsssLayout, htmlLoader = false, loadingTrans = "") => {
  const loadingContainer = document.createElement("div");
  loadingContainer.className = "loading-container-child";

  if (!htmlLoader) {
    if (ebsssLayout.commonAppSettings.customer_area_logo) {
      const img = document.createElement("img");
      img.alt = "...";
      img.className = "ebsss-load-breath-effect";
      img.src = remotePath.assetsUrl(ebsssLayout.commonAppSettings.customer_area_logo);
      img.width = 100;
      img.loading = "lazy";
      img.style.height = "auto";

      loadingContainer.appendChild(img);
    } else {
      const skeletonDiv = document.createElement("div");
      skeletonDiv.className = "ebsss-load-breath-effect";
      skeletonDiv.innerHTML = `${loadingTrans}`;
      skeletonDiv.style.width = "100px";
      skeletonDiv.style.height = "100px";

      loadingContainer.appendChild(skeletonDiv);
    }
  } else {
    const containerLoader = document.createElement("div");
    if (ebsssLayout?.loader) {
      containerLoader.innerHTML = ebsssLayout?.loader;
      containerLoader?.querySelector(joinedLoadingElementClassNames)?.classList?.add("position-relative");
      loadingContainer?.appendChild(containerLoader);
    }
  }

  return loadingContainer;
};
